/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, codec: NonNullable<unknown> }} Audio_Embed_Export_Stream_VideoInputs */



/**
* | output |
* | --- |
* | "Video {index}: {codec}" |
*
* @param {Audio_Embed_Export_Stream_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_stream_video = /** @type {((inputs: Audio_Embed_Export_Stream_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Stream_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vidéo ${i?.index}: ${i?.codec}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Video ${i?.index}: ${i?.codec}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Video ${i?.index}: ${i?.codec}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Видео ${i?.index}: ${i?.codec}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Vídeo ${i?.index}: ${i?.codec}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`视频 ${i?.index}: ${i?.codec}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオ ${i?.index}: ${i?.codec}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो ${i?.index}: ${i?.codec}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Vídeo ${i?.index}: ${i?.codec}`)
	return /** @type {LocalizedString} */ (`Video ${i?.index}: ${i?.codec}`)
});